import { Box, Heading, HStack, Switch, FormControl, FormLabel } from "@chakra-ui/react";
import SettingsHeader from "../elements/SettingsHeader";
import SettingsDescription from "../elements/SettingsDescription";
import InviteMember from "../elements/InviteMember";
import { useTenant } from "modules/tenant/providers/tenant-provider";
import TeamMemberList from "./TeamMemberList";
import Permissions from "./CustomPermissions";
import { isPermissionEnabled } from "utils/permissionHelper";
import { useRoles } from "hooks/useRoles";
import { useState } from "react";

export default function UserPermissions() {
  const { user } = useTenant();
  const [showInactive, setShowInactive] = useState(false);

  const {
    roles: lenderRoles,
    members: lenderMembers,
    invalidate: invalidateLender,
  } = useRoles({
    userType: "lender",
    company_id: user.company.id,
  });

  // Combine both role types and format display names
  const allRoles = [...(lenderRoles || [])].map(role => ({
    ...role,
    displayName: `${role.name}`,
  }));

  // Combine both member types and filter based on showInactive state
  const allMembers = [...(lenderMembers || [])].filter(member =>
    showInactive ? true : member.is_active
  );

  const invalidate = async () => {
    await invalidateLender();
  };

  return (
    <>
      <SettingsHeader title="User Roles & User Permissions" />
      <SettingsDescription text="Add members and edit user permissions here." />
      <HStack spacing="45px" alignItems="top">
        <Box flex="2">
          <HStack justifyContent="space-between" mb={4}>
            <Heading fontSize={18} fontWeight="600" lineHeight="21px">
              Team Members
            </Heading>
            <FormControl display="flex" alignItems="center" width="auto">
              <FormLabel htmlFor="show-inactive" mb="0" fontSize="14px" cursor="pointer">
                Show Inactives
              </FormLabel>
              <Switch
                id="show-inactive"
                isChecked={showInactive}
                onChange={e => setShowInactive(e.target.checked)}
                colorScheme="green"
              />
            </FormControl>
          </HStack>
          <TeamMemberList
            members={allMembers}
            roles={allRoles}
            onLoad={invalidate}
            isLoading={false}
          />
        </Box>
        <Box flex="1">
          <InviteMember roles={allRoles} onLoad={invalidate} />
        </Box>
      </HStack>
      {isPermissionEnabled(user) && (
        <Box>
          <Permissions />
        </Box>
      )}
    </>
  );
}
